angular.module('ShellServices')
	.run(['$translatePartialLoader', '$translate', ($translatePartialLoader, $translate) => {
			$translatePartialLoader.addPart('authoring-homepage-ui');
			$translate.refresh();
	}]);



// WEBPACK FOOTER //
// ./app/common/i18nConfig.js